import { Modal, Button, Group, Text } from '@mantine/core';
import { IconClock } from '@tabler/icons-react';

interface SessionTimeoutModalProps {
  opened: boolean;
  secondsRemaining: number;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

export function SessionTimeoutModal({
  opened,
  secondsRemaining,
  onStayLoggedIn,
  onLogout,
}: SessionTimeoutModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onStayLoggedIn}
      title={
        <Group gap="xs">
          <IconClock size={20} style={{ color: 'var(--color-accent-primary)' }} />
          <span>Session Expiring</span>
        </Group>
      }
      centered
      size="sm"
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
      overlayProps={{ backgroundOpacity: 0.55, blur: 3 }}
    >
      <Text size="sm" c="dimmed" mb="md">
        Your session will expire due to inactivity.
      </Text>

      <Text
        size="xl"
        fw={700}
        ta="center"
        mb="lg"
        style={{ color: 'var(--color-accent-primary)', fontVariantNumeric: 'tabular-nums' }}
      >
        {secondsRemaining}s
      </Text>

      <Group justify="flex-end">
        <Button variant="subtle" color="gray" onClick={onLogout}>
          Log Out
        </Button>
        <Button
          onClick={onStayLoggedIn}
          styles={{
            root: {
              backgroundColor: 'var(--color-accent-primary)',
              color: '#0a0a0f',
              '&:hover': { backgroundColor: 'var(--color-accent-secondary)' },
            },
          }}
        >
          Stay Logged In
        </Button>
      </Group>
    </Modal>
  );
}
